import { defineStore } from 'pinia';
import {getBrowserLanguage} from "@/helpers/helpers.js";

export const useConfigStore = defineStore('config', {
  state: () => ({
    config: {
      locations: [],
    },
    developerUrl: null,
    environment: null,
    lang: getBrowserLanguage(),
    locationId: null,
    employeeId: null,
  }),
  getters: {
    currentLang() {
      return this.lang;
    },
    currentLocationId() {
      return this.locationId;
    },
    currentLocation() {
      return this.config.locations.find(location => location.id === this.locationId) || {};
    },
    currentEmployeeId() {
      return this.employeeId;
    },
  },
  actions: {
    setConfig(config) {
      this.config = config;
    },
    setDeveloperUrl(url) {
      this.developerUrl = url;
    },
    setEnvironment(environment) {
      this.environment = environment;
    },
    setLang(lang) {
      this.lang = lang;
    },
    setLocationId(locationId) {
      this.locationId = locationId;
    },
    setEmployeeId(employeeId) {
      this.employeeId = employeeId;
    },
    clearConfig() {
      this.config = null;
      this.developerUrl = null;
      this.environment = null;
      this.lang = getBrowserLanguage();
      this.locationId = null;
    }
  },
  persist: { storage: localStorage },
});
